export const STAGES = [
  { id: "Pre-Seed or Seed", desc: "Early teams building product, refining their business model, pre-revenue.", risk: "Highest risk" },
  { id: "Series A or B", desc: "Startups with product-market fit and revenue, still in the early phases of growth.", risk: "Elevated risk" },
  { id: "Late stage / C+", desc: "Scaling operations, expanding markets, increasing revenue.", risk: "Moderate risk" },
];

export const FLOWS = [
  { id: "lead", label: "Institutional lead firms", desc: "The most selective option. Deals in rounds led by firms managing USD 200m or more in AUM.", vol: "~ 2 deals /mo" },
  { id: "co", label: "Institutional co-investors", desc: "Deals in rounds where one or more co-investors are firms managing USD 200m or more in AUM.", vol: "~ 5 deals /mo" },
  { id: "all", label: "All available deals", desc: "The broadest option. Every deal available to you.", vol: "~ 10 deals /mo" },
];

export const SECTORS = [
  "Adtech", "Aerospace", "AI / ML", "Analytics", "Biotech", "Blockchain / Crypto", "Cannabis",
  "Cleantech", "Collaboration Tools", "Consumer", "Dating", "Defense", "Developer Tools", "Drones",
  "E-Commerce", "Education", "Energy", "Enterprise", "Finance", "Fitness", "Food / Beverages",
  "Media / Entertainment", "Medical Devices", "Non Tech", "On Demand", "Payments", "Productivity",
  "Real Estate", "Retail", "Robotics", "SaaS", "Sales Tools", "Security", "Social", "Social Impact",
  "Transportation", "Travel", "VR / AR",
];

export const FUND_SIZES = ["Less than 50 million", "50 - 500 million", "Greater than 500 million"];

export const MANAGER_EXP = ["1 (Emerging manager)", "2-3 (Building track record)", "4+ (Established manager)"];

export const ASSET_CLASSES = [
  { id: "Private equity", desc: "Invests in private companies to improve operations, drive growth, and eventually realize returns through a sale or IPO." },
  { id: "Real estate", desc: "Pooled investments in income-generating property, held for yield and long term appreciation." },
];
